module.exports = __webpack_public_path__ + "media/media/home/img4-5bdef73154197533968ac5bad1978160.png";